import moment from '@this/src/lib/moment';

export const formatTimestamp = (timestamp: string) => moment(timestamp).tz('Asia/Tokyo').format('HH:mm');
